import { useEffect } from "react";

function Widget() {
    useEffect(() => {
        if (document.getElementById('widget-iframe')) return;

        const iframe = document.createElement('iframe');
        iframe.id = 'widget-iframe';

        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '220px';
        iframe.style.height = '80px';
        iframe.style.border = 'none';
        iframe.style.zIndex = '40';

        document.body.appendChild(iframe);

        const doc = iframe.contentDocument || iframe.contentWindow.document;
        doc.open();

        doc.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <meta name="viewport" content="width=device-width, initial-scale=1">
            </head>
            <body>
                <script src="https://storage.googleapis.com/ownchat/chat-widget/chat-widget-message-v7.js"></script>

                <script>
                    var options = {
                        waId: "+917010077448",
                        siteLogo: window.location.origin + "/fav.png",
                        siteName: "Kaigal",
                        siteTag: "24/7",
                        headerBgColor: "#2b2a7b",
                        headerTextColor: "light",
                        btnBgColor: "#ee6a29",
                        btnTextColor: "light",
                        CTAText: "Need Assistance?",
                        widgetPosition: "right",
                        welcomeMessage: "Thank you for reaching out to Kaigal - Blue-collar & Entry level employees recruitment platform",
                        replyOptions: ["Looking for employees?", "Need Job?", ""],
                    };

                    myFunction(1, options);

                    var lastState = null;

                    function checkState() {
                        var el = document.getElementById('chat_body');
                        var isOpen = el && el.offsetHeight > 50;

                        if (isOpen !== lastState) {
                            lastState = isOpen;
                            parent.postMessage({ type: 'widget-state', isOpen: isOpen }, '*');
                        }
                    }

                    setInterval(checkState, 500);
                </script>
            </body>
            </html>
        `);

        doc.close();

        window.addEventListener('message', (e) => {
            if (!e.data || e.data.type !== 'widget-state') return;

            if (e.data.isOpen) {
                const isMobile = window.innerWidth <= 768;
                iframe.style.width = isMobile ? '100vw' : '400px';
                iframe.style.height = isMobile ? '100vh' : '600px';
            } else {
                iframe.style.width = '220px';
                iframe.style.height = '80px';
            }
        });

        return () => {
            const existing = document.getElementById('widget-iframe');
            if (existing) existing.remove();
        };
    }, []);

    return null;
}

export default Widget;